// The fast path into SurrealDB, sitting between the page intro and the first
// section heading.
.banner {
	position: relative;
	margin-block: var(--mantine-spacing-xl);
	padding: var(--mantine-spacing-xl);
	background: var(--docs-card);
	overflow: hidden;
}

// The marks say which agents this covers without spending a line of copy on it.
// They are drawn in one colour, at full strength, so they read as one set.
.marks {
	opacity: 1;
}

// The link beside the prompt, as www.surrealdb.com draws its text links: the
// accent colour, with an accent underline that grows from left to right on hover while the
// arrow steps along with it. Not named `link`: the compiled `_link_` would
// match the markdown link rule in override.scss and draw a second underline.
.more-link {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	color: var(--docs-accent-text);

	&:hover,
	&:focus-visible {
		color: var(--docs-accent-text);

		.link-label {
			background-size: 100% 2px;
		}

		.link-arrow {
			transform: translateX(4px);
		}
	}
}

.link-label {
	padding-bottom: 4px;
	background-image: linear-gradient(var(--docs-accent), var(--docs-accent));
	background-position: 0 100%;
	background-repeat: no-repeat;
	background-size: 0% 2px;
	transition: background-size 300ms cubic-bezier(0.525, 0, 0, 1);
}

.link-arrow {
	flex-shrink: 0;
	transition: transform 300ms cubic-bezier(0.525, 0, 0, 1);
}

@media (prefers-reduced-motion: reduce) {
	.link-label,
	.link-arrow {
		transition: none;
	}
}

// Light mode draws the edge with a 1px line instead of a fill.
.banner {
	@include light {
		border: 1px solid var(--surreal-border-default);
	}
}
